import { apiUrl } from '../../../settings'

export let LeadsListURL = () => {
  return `${apiUrl}/leads`
}